import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle,
} from 'components/common/Dialog';

import { submit, isSubmitting, isDirty, getFormValues } from 'redux-form';

import Button from 'components/common/Button';
import Progress from 'components/common/Progress';

import objectDiff from 'utils/objectDiff';

import { fetchDefaultReportStructure, clearDefaultReportStructure } from 'redux/modules/defaultReportStructure';
import { fetchReportStructure, deleteReportStructure } from 'redux/modules/reportStructures';

import ReportStructureCreateEditForm from './ReportStructureCreateEditForm';

const styles = theme => ({
  paper: {
    waxWidth: 1200,
    minWidth: 1200,
    minHeight: 690,
  },
  form: {
    overflow: 'hidden',
    padding: '35px 20px 0',
    [theme.breakpoints.down('sm')]: {
      padding: '8px 8px 0',
    },
  },
});

const ReportStructureCreateEditDialog = ({
  form,
  initialValues,
  ID,
  open,
  onClose,
  onDelete,
  onSubmitSuccess,
  submitting,
  actions,
  dirty,
  formValues,
  defaultReportStructure,
  loading,
  account,
  classes,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    onEnter={() => {
      actions.clearDefaultReportStructure();
      actions.fetchDefaultReportStructure({ triggerLoading: true });
      if (ID) {
        actions.fetchReportStructure({
          triggerLoading: true,
          ID,
        });
      }
    }}
    maxWidth="md"
    classes={{
      paper: classes.paper,
    }}
  >
    <DialogTitle>
      <Typography
        variant="title"
        color="secondary"
        align="center"
      >
        Customize Report Columns Template
      </Typography>
    </DialogTitle>
    <DialogContent withScrollbars>
      {loading > 0 ? (
        <Progress />
      ) : (
        <ReportStructureCreateEditForm
          className={classes.form}
          form={form}
          formValues={formValues}
          defaultReportStructure={defaultReportStructure}
          initialValues={initialValues || {
            'Report Type': 'Order',
            Structure: defaultReportStructure.reduce((accumulator, currentValue) =>
              ({ ...accumulator, [currentValue]: true }), {}),
          }}
          onSubmitSuccess={(values) => {
            onClose();
            onSubmitSuccess(values);
          }}
          ID={ID}
          account={account}
          onDelete={() => {
            actions.deleteReportStructure({ ID });
            onClose();
            onDelete();
          }}
        />
      )}
    </DialogContent>
    <DialogActions>
      <Button
        onClick={onClose}
        variant="raised"
      >
        Cancel
      </Button>
      <Button
        onClick={() => {
          if (ID) {
            if (Object.keys(objectDiff(formValues, initialValues)).length > 0) {
              actions.submit(form);
            } else {
              onClose();
            }
          } else if (dirty) {
            actions.submit(form);
          } else {
            onClose();
          }
        }}
        variant="raised"
        color="primary"
        disabled={submitting}
      >
        Save
      </Button>
    </DialogActions>
  </Dialog>
);

ReportStructureCreateEditDialog.propTypes = {
  open: PropTypes.bool,
  form: PropTypes.string.isRequired,
  initialValues: PropTypes.shape({
    'First Name': PropTypes.string,
    'Last Name': PropTypes.string,
    'Middle Name': PropTypes.string,
    Phone: PropTypes.string,
    Email: PropTypes.string,
  }),
  ID: PropTypes.number,
  onClose: PropTypes.func,
  onDelete: PropTypes.func,
  onSubmitSuccess: PropTypes.func,
  submitting: PropTypes.bool.isRequired,
  dirty: PropTypes.bool.isRequired,
  actions: PropTypes.shape({
    fetchDefaultReportStructure: PropTypes.func.isRequired,
    clearDefaultReportStructure: PropTypes.func.isRequired,
    submit: PropTypes.func.isRequired,
  }).isRequired,
  formValues: PropTypes.shape({
    'First Name': PropTypes.string,
    'Last Name': PropTypes.string,
    'Middle Name': PropTypes.string,
    Phone: PropTypes.string,
    Email: PropTypes.string,
  }),
  classes: PropTypes.shape({
    form: PropTypes.string.isRequired,
  }).isRequired,
};

ReportStructureCreateEditDialog.defaultProps = {
  open: false,
  initialValues: null,
  ID: null,
  onClose: () => {},
  onDelete: () => {},
  onSubmitSuccess: () => {},
  formValues: null,
};

const mapStateToProps = (store, ownProps) => {
  const reportStructure = ownProps.ID ? store.reportStructures.data.find(item => item.ID === ownProps.ID) : null;
  return {
    initialValues: reportStructure ? reportStructure : null,
    submitting: isSubmitting(ownProps.form)(store),
    dirty: isDirty(ownProps.form)(store),
    formValues: getFormValues(ownProps.form)(store),
    defaultReportStructure: store.defaultReportStructure.data,
    account: store.account,
    loading: store.defaultReportStructure.loading
      + store.reportStructures.loading,
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    fetchDefaultReportStructure,
    clearDefaultReportStructure,
    fetchReportStructure,
    deleteReportStructure,
    submit,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(ReportStructureCreateEditDialog),
);



// WEBPACK FOOTER //
// ./src/components/reports/ReportStructureCreateEditDialog/ReportStructureCreateEditDialog.js